import {useCookie} from 'react-use'
import {LEAD_ID_STORAGE_KEY, MOSS_DOMAIN} from 'src/common/constants'

export const useLeadIdCookie = () => {
  const [leadIdCookie, updateLeadIdCookie] = useCookie(LEAD_ID_STORAGE_KEY)

  const getLeadId = (): string | null => (leadIdCookie ? leadIdCookie : null)

  const setLeadId = (leadId: string) => {
    updateLeadIdCookie(leadId, {
      domain: MOSS_DOMAIN,
    })
  }

  return {
    leadId: getLeadId(),
    setLeadId,
  }
}
